import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { filter, mergeMap } from 'rxjs/operators';
import { from } from 'rxjs';
import * as DomainsActions from '../entities/domains/domains.actions';
import * as FeaturesActions from '../entities/features/features.actions';
import * as TagsActions from '../entities/tags/tags.actions';

@Injectable()
export class DomainChangeCoordinatorEffects {
  private actions$ = inject(Actions);

  onDomainChange$ = createEffect(() =>
    this.actions$.pipe(
      ofType(DomainsActions.setCurrentDomainId),
      filter((action) => action.domainId !== null),
      mergeMap(() => {
        // Convert array of actions into a stream that emits each action
        // NgRx will dispatch all of them automatically
        return from([
          FeaturesActions.loadFeatures(),
          TagsActions.resetTagsState(),
          TagsActions.loadTags({}),
        ]);
      })
    )
  );
}

